
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorDisplayProps {
  errorMessage: string | null;
  onRetry: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  errorMessage,
  onRetry
}) => {
  return (
    <div className="p-6 space-y-4">
      <div className="flex items-start gap-3 p-4 border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 rounded-lg">
        <AlertTriangle className="h-5 w-5 text-amber-500 mt-0.5 shrink-0" />
        <div className="space-y-2">
          <h5 className="font-medium text-amber-700 dark:text-amber-400">
            Analysis Warning
          </h5>
          <p className="text-sm text-amber-600 dark:text-amber-500">
            {errorMessage || "There may be issues analyzing this page. Some features might be limited."}
          </p>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onRetry}
            className="mt-2 bg-amber-900/30 hover:bg-amber-900/50 text-amber-300 border-amber-700"
          >
            Try Analysis Anyway
          </Button>
        </div>
      </div>
    </div>
  );
};
